import { getFrontendUrl } from '../Services/helpers.jsx'

const getCurrentLang = () => (document.documentElement.lang || 'en').split('-')[0]

export const externalFAQRoute = {
    'ar': '/الأسئلة-الشائعة',
    'da': '/ofte-stillede-spørgsmål',
    'de': '/haeufig-gestellte-fragen',
    'el': '/συχνές-ερωτήσεις',
    'en': '/frequently-asked-questions',
    'es': '/preguntas-frecuentes',
    'fi': '/usein-kysytyt-kysymykset',
    'fr': '/questions-fréquentes',
    'he': '/שאלות-נפוצות',
    'hu': '/gyakori-kerdesek',
    'it': '/domande-frequenti',
    'ja': '/よくある-ご質問',
    'ko': '/자주-묻는-질문-faq',
    'nb': '/ofte-stilte-spørsmål',
    'nl': '/veelgestelde-vragen',
    'pl': '/często-zadawane-pytania',
    'pt': '/perguntas-frequentes',
    'ro': '/întrebări-frecvente',
    'ru': '/часто-задаваемые-вопросы',
    'sv': '/vanliga-frågor',
    'tr': '/sıkça-sorulan-sorular',
    'zh': '/常见问题'
}

export const externalConfidentialityRoute = {
    'ar': '/السرية',
    'da': '/fortrolighed',
    'de': '/datenschutz',
    'el': '/εμπιστευτικότητα',
    'en': '/confidentiality',
    'es': '/confidencialidad',
    'fi': '/luottamuksellisuus',
    'fr': '/confidentialite',
    'he': '/סודיות',
    'hu': '/titoktartas',
    'it': '/riservatezza',
    'ja': '/守秘義務',
    'ko': '/기밀-준수',
    'nb': '/konfidensialitet',
    'nl': '/vertrouwelijkheid',
    'pl': '/poufność',
    'pt': '/reserva',
    'ro': '/confidențialitate',
    'ru': '/конфиденциальность',
    'sv': '/sekretess',
    'tr': '/gizlilik',
    'zh': '/保密'
}

export const externalSalesConditionsRoute = {
    'en': '/terms-of-sale',
    'it': '/condizioni-vendita',
    'es': '/condiciones-de-venta',
    'fr': '/conditions-de-vente',
    'de': '/verkaufsbedingungen',
    'pt': '/condicoes-de-venda'
}

export const externalApiSpecsRoute = {
    'en': '/developers',
    'it': '/sviluppatori',
    'es': '/desarrolladores',
    'fr': '/developpeurs',
    'de': '/entwickler',
    'pt': '/desenvolvedores'
}

export const getLinkToConfidentiality = () => {
  const currentLang = getCurrentLang()
  const baseUrl = getFrontendUrl()
  const confidentialityPath = externalConfidentialityRoute[currentLang] || externalConfidentialityRoute['en']
  return `${baseUrl}${confidentialityPath}`
}

export const getLinkToSalesConditions = () => {
  const currentLang = getCurrentLang()
  const baseUrl = getFrontendUrl()
  const salesConditionsPath = externalSalesConditionsRoute[currentLang] || externalSalesConditionsRoute['en']
  return `${baseUrl}${salesConditionsPath}`
}

export const getLinkToApiSpecs = () => {
  const currentLang = getCurrentLang()
  const baseUrl = getFrontendUrl()
  const apiSpecsPath = externalApiSpecsRoute[currentLang] || externalApiSpecsRoute['en']
  return `${baseUrl}${apiSpecsPath}`
}

export const externalOrderRoute = {
    'ar': '/طلب',
    'da': '/ordre',
    'de': '/bestellung',
    'el': '/παραγγελία',
    'en': '/order',
    'es': '/ordinatión',
    'fi': '/tilaus',
    'fr': '/commande',
    'he': '/הזמנה',
    'hu': '/megrendeles',
    'it': '/ordine',
    'ja': '/ご注文',
    'ko': '/order-ko',
    'nb': '/bestill',
    'nl': '/bestelling',
    'pl': '/zamówienie',
    'pt': '/pedido',
    'ro': '/comandă',
    'ru': '/заказ',
    'sv': '/beställning',
    'tr': '/order-tr',
    'zh': '/订购'
}

export const getLinkToOrder = () => {
  const currentLang = getCurrentLang()
  const baseUrl = getFrontendUrl()
  const orderPath = externalOrderRoute[currentLang] || externalOrderRoute['en']
  return `${baseUrl}${orderPath}`
}